export default {
  title: 'Note legali',
  subtitle: 'Compaiono nel piè di pagina del tuo negozio online e del tuo sito solo dopo il salvataggio.',
  card_title: 'Note legali',
  placeholder: 'Inserisci le tue note legali',
  status: {
    saved: 'Salvato',
    not_shown: 'Non ancora visibili nel tuo negozio o sul tuo sito',
    unsaved: "Modifiche non salvate: negozio e sito mostrano l'ultima versione salvata",
  },
  save: 'Salva',
  retry: 'Riprova',
  preview: {
    title: 'Anteprima del piè di pagina (negozio e sito)',
    terms: 'Termini',
    privacy: 'Privacy',
    cookies: 'Cookie',
    imprint: 'Note legali',
  },
  toasts: {
    saved: 'Note legali salvate',
    save_failed: 'Impossibile salvare le note legali. Riprova.',
    load_failed: 'Impossibile caricare le note legali. Ricarica la pagina.',
  },
};
